import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {get as _get} from 'lodash';

import {getLink} from '@appComponents/Link';
import {convertToInt} from '@utils/helpers';
import mapModulesToProps from '@utils/mapModulesToProps';
import {PRODUCT_LCI} from '@constants/variables';

import {deleteSuccessCallback, setClientProductsEntity} from '../utils/clientProducts';
import ClientProductForm from './ClientProductForm';

export class ClientProductLciForm extends ClientProductForm {
    componentDidMount() {
        super.componentDidMount();

        const entityName = 'client',
            params = {
                clientData: this.props.clientData,
                entityName,
                setEntity: this.props.Entity.setEntity,
            };

        this.setCreateSuccessCallback((response) => {
            this.props.Entity.setEntity({
                name: entityName,
                data: {...this.props.clientData,
                    clientProducts: this.props.clientData.clientProducts.concat(
                        response.data.createClientProductLci.client_product
                    ),
                },
            });

            this.props.history.push(getLink('clients.products.lci.editGeoRestrictions', {
                id: this.props.match.params.id,
            }));
        });

        this.setUpdateSuccessCallback((response) => {
            const clientProductLciIndex = this.props.clientData.clientProducts.findIndex(clientProduct =>
                    PRODUCT_LCI === convertToInt(clientProduct.product.id)
                ),
                clientProducts = {};

            clientProducts[clientProductLciIndex] = {
                ...response.data.updateClientProductLci.client_product,
            };
            params.clientProducts = clientProducts;

            setClientProductsEntity(params);
        });

        this.setDeleteSuccessCallback(() => {
            params.formParamsId = this.props.formParams.id;
            params.historyPush = this.props.history.push;

            deleteSuccessCallback(params);
        });
    }

    componentDidUpdate(prevProps) {
        const {
            formParams,
            GraphQLEntityData,
            GraphQLOptionsData,
        } = this.props;

        const isAddForm = _get(formParams, 'isAddForm');
        const clientProductsLci = _get(GraphQLEntityData, 'clientProductsLci', []);
        const entityLoading = _get(GraphQLEntityData, 'loading', false);
        const optionsProduct = _get(GraphQLOptionsData, 'product');
        const optionsLoading = _get(GraphQLOptionsData, 'loading', false);
        let augmentedPrevProps = prevProps;

        if (!optionsLoading && !entityLoading && !this.state.dataReceived) {
            if (!isAddForm && 0 < clientProductsLci.length) {
                augmentedPrevProps = { ...prevProps, clientProduct: clientProductsLci[0].client_product };

                this.setField('id', {defaultValue: convertToInt(clientProductsLci[0].id)});
            }

            this.handleInitialSlaFieldVisibility(isAddForm, clientProductsLci, optionsProduct);
            super.componentDidUpdate(augmentedPrevProps);
        }
    }

    prepareDataForSubmit(data) {
        data = {...data, product: PRODUCT_LCI};

        return super.prepareDataForSubmit(data);
    }
}

const mapDispatchToProps = mapModulesToProps(['Entity']),
    mapStateToProps = (state) => ({clientData: state.app.entities.client || null});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ClientProductLciForm));
